import React from "react";
import { TurnrTableCell } from "../TurnrTableSmart.jsx";
import DotsMenu from "../../DotsMenu";

export function getTableHeadActions({ ...rest } = {}) {
    return {
        id: "actions",
        sortable: false,
        ...rest,
    };
}

export function TableCellActions({ items, children, ...rest } = {}) {
    return (
        <TurnrTableCell tight align="right" {...rest} style={{ width: "0.0001%" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>{children || <DotsMenu style={{ marginLeft: "auto" }} items={items} />}</div>
        </TurnrTableCell>
    );
}
